export const contactsData = {
    email: 'harondev.net@gmail.com',
    phone: '+254707058437',
    address: 'Nairobi, Kenya',

    sheetAPI: ''
}